import { Button, Group, Modal, Stack, Text, useMantineTheme } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

interface DeleteChannelFinalConfirmationModalProps {
  opened: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  channelName: string
  isLoading?: boolean
}

/**
 * Final "really sure?" step shown after DeleteChannelModal's checkbox +
 * type-to-confirm guards have already been cleared.
 */
export function DeleteChannelFinalConfirmationModal({
  opened,
  onClose,
  onConfirm,
  channelName,
  isLoading = false,
}: DeleteChannelFinalConfirmationModalProps) {
  const theme = useMantineTheme()
  const trimmedChannelName = channelName.trim()

  const handleClose = () => {
    if (isLoading) return
    onClose()
  }

  return (
    <Modal.Root opened={opened} onClose={handleClose} centered closeOnClickOutside={!isLoading}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <IconAlertTriangle
            size={24}
            style={{ minWidth: 24, color: 'var(--mantine-color-red-6)', marginRight: theme.spacing.xs }}
          />
          <Modal.Title fw={600}>Confirm deletion?</Modal.Title>
          <Modal.CloseButton disabled={isLoading} />
        </Modal.Header>
        <Modal.Body pt="xs">
          <Stack gap="lg">
            <Text size="sm">
              Please confirm that you want to delete{' '}
              <Text span fw={600}>
                {trimmedChannelName}
              </Text>
              . This action cannot be undone.
            </Text>

            <Group justify="flex-end" gap="sm" mt="sm">
              <Button variant="default" onClick={handleClose} disabled={isLoading}>
                Cancel
              </Button>
              <Button color="red" onClick={() => void onConfirm()} loading={isLoading}>
                Delete &amp; Log Out
              </Button>
            </Group>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
